export default "__VITE_ASSET__BTwrxrds__"